import React from "react";

import {
  Column,
  Row,
  MainWrapper,
  Header,
  Content,
  H2,
  Avatar,
  Input,
  Label,
  TextArea,
  Anchor,
  Dropdown,
  Grid,
  Switch,
  HR,
  AutoComplete,
  Collapsible,
  Modal,
  ModalFooter,
  Button,
} from "../../../components";

import { Menu } from "../Menu";

export const Group = ({ children, label, marginTop }) => (
  <Column marginTop={marginTop || 0}>
    <Row marginBottom="10">
      <Label bold>{label}</Label>
    </Row>
    <Row marginTop="5">{children}</Row>
  </Column>
);

export const DropdownGroup = ({
  field,
  label,
  value,
  handleChangeAndUpdate,
  items,
  readOnly,
  maxWidth,
}) => (
  <Group {...{ label }}>
    <Dropdown
      expand
      select
      {...{ value, items, readOnly, maxWidth }}
      onChange={(e) =>
        handleChangeAndUpdate({
          value: e.id,
          field,
        })
      }
    />
  </Group>
);

export const InputGroup = ({
  field,
  label,
  value,
  handleChange,
  handleUpdate,
  multiline,
  marginTop,
  iconAction,
  errorMessage,
}) => (
  <Group {...{ label, marginTop }}>
    {!multiline ? (
      <Input
        small
        placeholder={label}
        value={value}
        errorMessage={errorMessage}
        onChange={(e) =>
          handleChange({
            value: e.target?.value,
            field,
          })
        }
        reverse
        icon={iconAction ? "close" : ""}
        iconAction={iconAction}
        onBlur={handleUpdate}
      />
    ) : (
      <TextArea
        small
        expand
        placeholder={label}
        value={value}
        // errorMessage={errors[field]}
        onChange={(e) =>
          handleChange({
            value: e.target?.value,
            field,
          })
        }
        onBlur={handleUpdate}
      />
    )}
  </Group>
);

const getHCPAccountTypes = () => {
  return [{ id: "PERSON", label: "Person" }];
};

const getHCPAccountSubtypes = () => {
  return [
    { id: "HCP", label: "HCP" },
    { id: "ADVOCATE", label: "Advocate" },
    { id: "RESEARCHER", label: "Researcher" },
  ];
};

const getInstitutionAccountTypes = () => {
  return [{ id: "INSTITUTION", label: "Institution" }];
};

const getInstitutionAccountSubtypes = () => {
  return [
    { id: "PHARMA", label: "Pharma" },
    { id: "ACADEMIC", label: "Academic" },
    { id: "ADVOCATE", label: "Advocate" },
    { id: "GOVERNMENT", label: "Government" },
    { id: "HOSPITAL", label: "Hospital" },
    { id: "RESEARCH", label: "Research" },
    { id: "SOCIETY", label: "Society" },
    { id: "CMEPROVIDER", label: "CME Provider" },
    { id: "LAB", label: "Lab" },
  ];
};

const getAccountTypes = (accountType) => {
  if (accountType === "PERSON") return getHCPAccountTypes();
  else if (accountType === "INSTITUTION") return getInstitutionAccountTypes();
  else
    return [
      ...getHCPAccountTypes(),
      ...getInstitutionAccountTypes(),
      { id: "OTHER", label: "Other" },
      { id: "UNKNOWN", label: "Unknown" },
    ];
};

const getAccountSubtypes = (accountType) => {
  if (accountType === "PERSON")
    return [
      ...getHCPAccountSubtypes(),
      { id: "OTHER", label: "Other" },
      { id: "UNKNOWN", label: "Unknown" },
    ];
  else if (accountType !== "PERSON")
    return [
      ...getInstitutionAccountSubtypes(),
      { id: "OTHER", label: "Other" },
      { id: "UNKNOWN", label: "Unknown" },
    ];
  else
    return [
      ...getHCPAccountSubtypes(),
      ...getInstitutionAccountSubtypes(),
      { id: "OTHER", label: "Other" },
      { id: "UNKNOWN", label: "Unknown" },
    ];
};

const getAudiences = () => {
  return [
    { id: "MO/DO", label: "MO/DO" },
    { id: "PhD", label: "PhD" },
    { id: "APs", label: "APs" },
    { id: "Patients", label: "Patients" },
  ];
};

const getContentCreatorStatus = () => {
  return [
    { id: "Creator and Amplifier", label: "Creator and Amplifier" },
    { id: "Amplifier", label: "Amplifier" },
  ];
};

const getContentFocus = () => {
  return [
    { id: "Clinical practice focus", label: "Clinical practice focus" },
    { id: "Patient focused", label: "Patient focused" },
    { id: "Scientific/data focused", label: "Scientific/data focused" },
    { id: "Trial and Research focused", label: "Trial and Research focused" },
  ];
};

const getDolExperience = () => {
  return [
    { id: "Established Voice", label: "Established Voice" },
    { id: "Rising Star", label: "Rising Star" },
    { id: "Enthusiast", label: "Enthusiast" },
  ];
};

const getKolInfluenceReach = () => {
  return [
    { id: "Not Designated", label: "Not Designated" },
    { id: "International", label: "International" },
    { id: "National", label: "National" },
    { id: "Regional", label: "Regional" },
  ];
};

const getPostEngegementRate = () => {
  return [
    { id: "high", label: "high" },
    { id: "medium", label: "medium" },
    { id: "low", label: "low" },
  ];
};

const getTones = () => {
  return [
    { id: "Casual", label: "Casual" },
    { id: "Formal", label: "Formal" },
    { id: "Text orientation", label: "Text orientation" },
    { id: "Visual orientation", label: "Visual orientation" },
    { id: "Short form", label: "Short form" },
    { id: "Longer form", label: "Longer form" },
  ];
};

const getPersonalities = () => {
  return [
    { id: "Builder", label: "Builder" },
    { id: "Constructive Provocateur", label: "Constructive Provocateur" },
    { id: "Intellect", label: "Intellect" },
    { id: "Competitor", label: "Competitor" },
    { id: "Destructive Provocateur", label: "Destructive Provocateur" },
    { id: "Defender", label: "Defender" },
    { id: "Collaborator", label: "Collaborator" },
  ];
};

const getPrimaryPostContents = () => {
  return [
    { id: "Text", label: "Text" },
    { id: "YouTube videos", label: "YouTube videos" },
    { id: "Text with image", label: "Text with image" },
    { id: "Journal articles", label: "Journal articles" },
    { id: "Polls", label: "Polls" },
  ];
};

export const view = ({
  hcp,
  errors,
  handleUpdate,
  handleChange,
  handleChangeAndUpdate,
  isInstitution,
  searchTerm,
  setSearchTerm,
  hcps,

  selectedInstitution,
  handleUpdateInstitution,
  infiniteScroll,
  handleClearInstitution,
  loadingInstitutions,

  countries,
  countryTerm,
  setCountryTerm,
  handleUpdateCountry,
  handleClearCountry,
  states,
  handleUpdateState,

  npiTaxonomies,
  handleChangeAndUpdateNpiTaxonomy,

  accountAttributes,
  handleUpdateAtribute,

  deleteModal,
  toggleDeleteModal,
  handleDeleteAccount,
  npiError,
}) => (
  <MainWrapper drawer>
    <Header
      drawer
      back
      rightContent={
        <Row>
          <Row marginX>
            <Anchor
              label="Delete"
              color="red"
              onClick={() => toggleDeleteModal(true)}
            />
          </Row>
        </Row>
      }
    />
    <Menu active={"accounts"} />
    {hcp && (
      <Content>
        <Column center>
          <Column maxWidth="700" paddingBottom="40">
            <Row expand paddingY="20">
              <H2 bold>Edit {isInstitution ? "institution " : "HCP"}</H2>
              <Row marginLeft>
                {hcp.imageURL && (
                  <Avatar imageUrl={hcp.imageURL} name={hcp.name} />
                )}
              </Row>
            </Row>

            <Column marginTop>
              <Grid columns={2} gap="30">
                {!isInstitution && (
                  <InputGroup
                    label="First Name"
                    field="firstName"
                    value={hcp.firstName}
                    {...{ handleChange, handleUpdate }}
                  />
                )}
                {!isInstitution && (
                  <InputGroup
                    label="Last Name"
                    field="lastName"
                    value={hcp.lastName}
                    {...{ handleChange, handleUpdate }}
                  />
                )}
                <InputGroup
                  label="Name"
                  field="name"
                  value={hcp.name}
                  {...{ handleChange, handleUpdate }}
                />
                <InputGroup
                  label="Twitter Handle"
                  field="username"
                  value={hcp.username}
                  {...{ handleChange, handleUpdate }}
                />
                <InputGroup
                  label="External Id"
                  field="externalId"
                  value={hcp.externalId}
                  {...{ handleChange, handleUpdate }}
                />
                <InputGroup
                  label="NPI Id"
                  field="npiId"
                  value={hcp.npiId}
                  errorMessage={npiError}
                  iconAction={() => {
                    handleChangeAndUpdate({
                      value: null,
                      field: "npiId",
                    });
                  }}
                  {...{ handleChange, handleUpdate }}
                />
                <InputGroup
                  label="Linkedin Id"
                  field="linkedInURL"
                  value={hcp.linkedInURL}
                  {...{ handleChange, handleUpdate }}
                />
              </Grid>
              <Column marginTop="30">
                <DropdownGroup
                  maxWidth="700"
                  label="NPI Taxonomy"
                  field="npiTaxonomies"
                  value={
                    hcp.npiTaxonomies?.length > 0
                      ? hcp.npiTaxonomies[0]?.taxonomyCode
                      : undefined
                  }
                  items={npiTaxonomies}
                  {...{
                    handleChangeAndUpdate: handleChangeAndUpdateNpiTaxonomy,
                  }}
                />
              </Column>
              <InputGroup
                label="Description"
                field="description"
                value={hcp.description}
                multiline
                marginTop="30"
                {...{ handleChange, handleUpdate }}
              />

              <Column marginY="40">
                <HR />
              </Column>
              <Grid columns={2} gap="30">
                <DropdownGroup
                  label="Account Type"
                  field="accountType"
                  value={hcp.accountType}
                  items={getAccountTypes(hcp?.accountType)}
                  {...{ handleChangeAndUpdate }}
                />
                <DropdownGroup
                  label="Account Subtype"
                  field="accountSubtype"
                  value={hcp.accountSubtype}
                  items={getAccountSubtypes(hcp?.accountType)}
                  {...{ handleChangeAndUpdate }}
                />
                <InputGroup
                  label="URL"
                  field="url"
                  value={hcp.url}
                  {...{ handleChange, handleUpdate }}
                />
                <InputGroup
                  label="Image URL"
                  field="imageURL"
                  value={hcp.imageURL}
                  {...{ handleChange, handleUpdate }}
                />
                <InputGroup
                  label="Twitter URL"
                  field="twitterURL"
                  value={hcp.twitterURL}
                  {...{ handleChange, handleUpdate }}
                />
              </Grid>

              <Column marginY="40">
                <Collapsible label={"Location"} open={isInstitution}>
                  <Column paddingTop="30" paddingBottom="40" paddingX>
                    <Grid columns={2} gap="30">
                      <InputGroup
                        label="Location"
                        field="location"
                        value={hcp.location}
                        {...{ handleChange, handleUpdate }}
                      />
                      <InputGroup
                        label="City"
                        field="city"
                        value={hcp.city}
                        {...{ handleChange, handleUpdate }}
                      />
                      <InputGroup
                        label="County"
                        field="county"
                        value={hcp.county}
                        {...{ handleChange, handleUpdate }}
                      />
                      <Group label="State / Province">
                        <Dropdown
                          expand
                          select
                          value={hcp.stateProvinceCode}
                          items={states}
                          onChange={handleUpdateState}
                        />
                      </Group>
                      <Group label="Country">
                        {/* <Dropdown
                          expand
                          select
                          value={hcp.countryCode}
                          items={countries}
                          onChange={handleUpdateCountry}
                        /> */}
                        <AutoComplete
                          showOnEmptyTerm
                          placeholder="Country"
                          displayTextFromSelected
                          searchResults={countries}
                          setSearchTerm={setCountryTerm}
                          searchTerm={countryTerm}
                          selectedItems={hcp.countryCode}
                          addItem={handleUpdateCountry}
                          hasClearButton
                          clearSearchResults={handleClearCountry}
                        />
                      </Group>
                      <InputGroup
                        label="Postal Code"
                        field="postalCode"
                        value={hcp.postalCode}
                        {...{ handleChange, handleUpdate }}
                      />
                    </Grid>
                  </Column>
                </Collapsible>
              </Column>

              {accountAttributes.length > 0 && (
                <Column marginTop="-10" marginBottom="40">
                  <Collapsible label={"Attributes"}>
                    <Column paddingTop="20" paddingBottom="40" paddingX>
                      <Grid columns={2} gap="30">
                        {accountAttributes.find((attr) => attr.attributeName === "AUDIENCE") && (
                          <Group label="Audience">
                            <Dropdown
                              multiple
                              multipleLabel="audiences"
                              expand
                              value={accountAttributes.find((attr) => attr.attributeName === "AUDIENCE")
                                ?.attributeValue?.split(",")
                                ?.map((k) => ({
                                  id: _.trim(k),
                                  label: _.trim(k),
                                }))}
                              items={getAudiences()}
                              onChange={(e) =>
                                handleUpdateAtribute(accountAttributes.find((attr) => attr.attributeName === "AUDIENCE").id,
                                  e.map((k) => k.id).filter(n => n !== "").join(", ")
                                )
                              }
                            />
                          </Group>
                        )}
                        {accountAttributes.find((attr) => attr.attributeName === "CONTENT_CREATOR_STATUS") && (
                          <Group label="Content Creator Status">
                            <Dropdown
                              expand
                              select
                              value={
                                accountAttributes.find((attr) => attr.attributeName === "CONTENT_CREATOR_STATUS")?.attributeValue
                              }
                              items={getContentCreatorStatus()}
                              onChange={(e) =>
                                handleUpdateAtribute(accountAttributes.find((attr) => attr.attributeName === "CONTENT_CREATOR_STATUS").id, e.id)
                              }
                            />
                          </Group>
                        )}
                        {accountAttributes.find((attr) => attr.attributeName === "CONTENT_FOCUS") && (
                          <Group label="Content Focus">
                            <Dropdown
                              expand
                              multiple
                              multipleLabel="content focuses"
                              value={accountAttributes
                                .find(
                                  (attr) =>
                                    attr.attributeName === "CONTENT_FOCUS"
                                )
                                ?.attributeValue?.split(",")
                                ?.map((k) => ({
                                  id: _.trim(k),
                                  label: _.trim(k),
                                }))}
                              items={getContentFocus()}
                              onChange={(e) =>
                                handleUpdateAtribute(
                                  accountAttributes.find(
                                    (attr) =>
                                      attr.attributeName === "CONTENT_FOCUS"
                                  ).id,
                                  e.map((k) => k.id).filter(n => n !== "").join(", ")
                                )
                              }
                            />
                          </Group>
                        )}
                        {accountAttributes.find((attr) => attr.attributeName === "DOL_EXPERIENCE") && (
                          <Group label="Dol Experience">
                            <Dropdown
                              expand
                              select
                              value={
                                accountAttributes.find((attr) => attr.attributeName === "DOL_EXPERIENCE")?.attributeValue
                              }
                              items={getDolExperience()}
                              onChange={(e) =>
                                handleUpdateAtribute(
                                  accountAttributes.find((attr) => attr.attributeName === "DOL_EXPERIENCE").id,
                                  e.id
                                )
                              }
                            />
                          </Group>
                        )}
                        {accountAttributes.find((attr) => attr.attributeName === "KOL_INFLUENCE_REACH") && (
                          <Group label="Kol Influence Reach">
                            <Dropdown
                              expand
                              select
                              value={
                                accountAttributes.find((attr) => attr.attributeName === "KOL_INFLUENCE_REACH")?.attributeValue
                              }
                              items={getKolInfluenceReach()}
                              onChange={(e) =>
                                handleUpdateAtribute(
                                  accountAttributes.find((attr) => attr.attributeName === "KOL_INFLUENCE_REACH").id,
                                  e.id
                                )
                              }
                            />
                          </Group>
                        )}
                        {accountAttributes.find((attr) => attr.attributeName === "POST_ENGAGEMENT_RATE") && (
                          <Group label="Post Engegement Rate">
                            <Dropdown
                              expand
                              select
                              value={
                                accountAttributes.find((attr) => attr.attributeName === "POST_ENGAGEMENT_RATE")?.attributeValue
                              }
                              items={getPostEngegementRate()}
                              onChange={(e) =>
                                handleUpdateAtribute(
                                  accountAttributes.find((attr) => attr.attributeName ==="POST_ENGAGEMENT_RATE").id,
                                  e.id
                                )
                              }
                            />
                          </Group>
                        )}
                        {accountAttributes.find((attr) => attr.attributeName === "TONE") && (
                          <Group label="Tone">
                            <Dropdown
                              multiple
                              multipleLabel="tones"
                              expand
                              value={accountAttributes
                                .find((attr) => attr.attributeName === "TONE")
                                ?.attributeValue?.split(",")
                                ?.map((k) => ({
                                  id: _.trim(k),
                                  label: _.trim(k),
                                }))}
                              items={getTones()}
                              onChange={(e) =>
                                handleUpdateAtribute(
                                  accountAttributes.find(
                                    (attr) => attr.attributeName === "TONE"
                                  ).id,
                                  e.map((k) => k.id).filter(n => n !== "").join(", ")
                                )
                              }
                            />
                          </Group>
                        )}
                        {accountAttributes.find((attr) => attr.attributeName === "PERSONALITY") && (
                          <Group label="Personality">
                            <Dropdown
                              multiple
                              multipleLabel="personalities"
                              expand
                              value={accountAttributes
                                .find(
                                  (attr) => attr.attributeName === "PERSONALITY"
                                )
                                ?.attributeValue?.split(",")
                                ?.map((k) => ({
                                  id: _.trim(k),
                                  label: _.trim(k),
                                }))}
                              items={getPersonalities()}
                              onChange={(e) =>
                                handleUpdateAtribute(
                                  accountAttributes.find(
                                    (attr) =>
                                      attr.attributeName === "PERSONALITY"
                                  ).id,
                                  e.map((k) => k.id).filter(n => n !== "").join(", ")
                                )
                              }
                            />
                          </Group>
                        )}
                        {accountAttributes.find((attr) => attr.attributeName === "PRIMARY_POST_CONTENT") && (
                          <Group label="Primary Post Content">
                            <Dropdown
                              multiple
                              multipleLabel="primary contents"
                              expand
                              value={accountAttributes
                                .find(
                                  (attr) =>
                                    attr.attributeName ===
                                    "PRIMARY_POST_CONTENT"
                                )
                                ?.attributeValue?.split(",")
                                ?.map((k) => ({
                                  id: _.trim(k),
                                  label: _.trim(k),
                                }))}
                              items={getPrimaryPostContents()}
                              onChange={(e) =>
                                handleUpdateAtribute(
                                  accountAttributes.find(
                                    (attr) =>
                                      attr.attributeName ===
                                      "PRIMARY_POST_CONTENT"
                                  ).id,
                                  e.map((k) => k.id).filter(n => n !== "").join(", ")
                                )
                              }
                            />
                          </Group>
                        )}
                        <br />
                        {accountAttributes.find((attr) => attr.attributeName === "SPECIALITY") && (
                          <Group label="Speciality">
                            <Input
                              small
                              placeholder="Speciality"
                              value={
                                accountAttributes.find(
                                  (attr) => attr.attributeName === "SPECIALITY"
                                )?.attributeValue
                              }
                              onBlur={(e) =>
                                handleUpdateAtribute(
                                  accountAttributes.find(
                                    (attr) =>
                                      attr.attributeName === "SPECIALITY"
                                  ).id,
                                  e.target?.value
                                )
                              }
                              reverse
                            />
                            {/* <Dropdown
                              multiple
                              multipleLabel="specialities"
                              expand
                              value={accountAttributes
                                .find(
                                  (attr) => attr.attributeName === "SPECIALITY"
                                )
                                ?.attributeValue?.split(",")
                                ?.map((k) => ({ id: _.trim(k), label: _.trim(k) }))}
                              items={npiTaxonomies.filter(k=>_.trim(k.label) !== "").map(m => ({id: m.label, label: m.label}))}
                              onChange={(e) =>
                                handleUpdateAtribute(
                                  accountAttributes.find(
                                    (attr) => attr.attributeName === "SPECIALITY"
                                  ).id,
                                  e.map((k) => k.id).join(", ")
                                )
                              }
                            /> */}
                          </Group>
                        )}
                        {accountAttributes.find((attr) => attr.attributeName === "PERSONAL_INTERESTS") && (
                          <Group label="Personal Interests">
                            <Input
                              small
                              placeholder="Personal Interests"
                              value={
                                accountAttributes.find(
                                  (attr) =>
                                    attr.attributeName === "PERSONAL_INTERESTS"
                                )?.attributeValue
                              }
                              onBlur={(e) =>
                                handleUpdateAtribute(
                                  accountAttributes.find(
                                    (attr) =>
                                      attr.attributeName ===
                                      "PERSONAL_INTERESTS"
                                  ).id,
                                  e.target?.value
                                )
                              }
                              reverse
                            />
                          </Group>
                        )}
                      </Grid>
                    </Column>
                  </Collapsible>
                </Column>
              )}

              <Grid columns={2} gap="30" marginTop="-10">
                <Switch
                  label="For Ingestion"
                  checked={hcp.forIngestion}
                  onChange={(e) => {
                    handleChangeAndUpdate({
                      value: e,
                      field: "forIngestion",
                    });
                  }}
                />
                <Switch
                  label="Verified"
                  checked={hcp.verified}
                  onChange={(e) => {
                    handleChangeAndUpdate({
                      value: e,
                      field: "verified",
                    });
                  }}
                />
                <DropdownGroup
                  label="Ingestion Reason"
                  field="ingestionReason"
                  value={hcp.ingestionReason}
                  items={[
                    { id: "PRIMARY", label: "Primary" },
                    { id: "SECONDARY", label: "Secondary" },
                    { id: "USERRQUEST", label: "User request" },
                    { id: "DEDUCED", label: "Deduced" },
                    { id: "FOLLOWED", label: "Followed" },
                    {
                      id: "SECONDARYFROMRETWEET",
                      label: "Secondary from repost",
                    },
                  ]}
                  {...{ handleChangeAndUpdate }}
                />
              </Grid>

              {hcp.accountType === "PERSON" && (
                <>
                  <Column marginY="40">
                    <HR />
                  </Column>
                  <Row marginBottom="10">
                    <Label bold>Institution</Label>
                  </Row>
                  <Grid columns={2} gap="30">
                    <AutoComplete
                      showOnEmptyTerm
                      placeholder="Institution"
                      displayTextFromSelected
                      searchResults={hcps}
                      setSearchTerm={setSearchTerm}
                      searchTerm={searchTerm}
                      selectedItems={selectedInstitution}
                      addItem={handleUpdateInstitution}
                      clearSearchResults={handleClearInstitution}
                      infiniteScroll={infiniteScroll}
                      hasClearButton
                      // searchLoading={loadingInstitutions}
                      searchLoading={false}
                    />
                  </Grid>
                  {selectedInstitution && selectedInstitution.length > 0 && (
                    <Column paddingTop>
                      <Collapsible
                        label="Institution Location"
                        open
                        rightAction={
                          <Anchor
                            bold
                            label="edit"
                            // reloadDocument
                            onClick={() =>
                              window.location.assign(
                                `/editAccount/${selectedInstitution[0].id}`
                              )
                            }
                          />
                        }
                      >
                        <Column paddingAll gap="5">
                          {selectedInstitution[0].location && (
                            <Row gap="10">
                              <Label>Location:</Label>
                              <Label bold>
                                {selectedInstitution[0].location}
                              </Label>
                            </Row>
                          )}
                          {selectedInstitution[0].city && (
                            <Row gap="10">
                              <Label>City:</Label>
                              <Label bold>{selectedInstitution[0].city}</Label>
                            </Row>
                          )}
                          {selectedInstitution[0].county && (
                            <Row gap="10">
                              <Label>County:</Label>
                              <Label bold>
                                {selectedInstitution[0].county}
                              </Label>
                            </Row>
                          )}
                          {selectedInstitution[0].stateProvince && (
                            <Row gap="10">
                              <Label>State:</Label>
                              <Label bold>
                                {selectedInstitution[0].stateProvince}
                              </Label>
                            </Row>
                          )}
                          {selectedInstitution[0].country && (
                            <Row gap="10">
                              <Label>Country:</Label>
                              <Label bold>
                                {selectedInstitution[0].country}
                              </Label>
                            </Row>
                          )}
                          {selectedInstitution[0].postalCode && (
                            <Row gap="10">
                              <Label>Postal Code:</Label>
                              <Label bold>
                                {selectedInstitution[0].postalCode}
                              </Label>
                            </Row>
                          )}
                        </Column>
                      </Collapsible>
                    </Column>
                  )}
                </>
              )}
            </Column>
          </Column>
        </Column>

        <Modal
          visible={deleteModal}
          toggleVisibility={toggleDeleteModal}
          title="Delete User"
          close
        >
          <Column marginBottom gap="20" center>
            <Label>
              <Label large bold>
                {hcp.name}
              </Label>
              <Label large> will be deleted</Label>
            </Label>
            <Label large>
              Are you sure you want to continue? This action cannot be undone.
            </Label>
          </Column>
          <ModalFooter right>
            <Button
              secondary
              label="Delete"
              onClick={() => handleDeleteAccount()}
            />
          </ModalFooter>
        </Modal>
      </Content>
    )}
  </MainWrapper>
);
